export function isCompanyRegistered(profile) {
  return Boolean(
    profile?.company_name?.trim()
    && profile?.company_address?.trim()
    && profile?.company_country?.trim()
    && profile?.economic_operator_type?.trim()
  );
}
